import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

// components
import {Button} from '@mui/joy';

// styles
import {
  PageWrapper,
  PageBodyWrapper,
  Icon404,
  IconBack,
  TextsWrapper,
} from './NotFoundPage-styles';
import {Subtitle, TitleExtraLarge} from '../../shared/styles';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <PageWrapper>
      <Icon404 />
      <PageBodyWrapper>
        <TextsWrapper>
          <TitleExtraLarge>{t('notFound_ooops')}</TitleExtraLarge>
          <Subtitle>{t('notFound_pageNotFound')}</Subtitle>
        </TextsWrapper>
        <Button
          size="lg"
          variant="plain"
          startDecorator={<IconBack />}
          onClick={() => navigate('/dashboard')}>
          {t('notFound_goBackDashboard')}
        </Button>
      </PageBodyWrapper>
    </PageWrapper>
  );
};

export default NotFoundPage;
